import { toString30pk9tzaqopn as toString } from '../Library.mjs';
import {
  hashCodeq5arwsb9dgti as hashCode,
  equals2au1ep9vhcato as equals,
} from '../js/coreRuntime.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../js/void.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var IndexedValueClass;
function IndexedValue() {
  if (IndexedValueClass === VOID) {
    class $ {
      constructor(index, value) {
        this.index_1 = index;
        this.value_1 = value;
      }
      toString() {
        return 'IndexedValue(index=' + this.index_1 + ', value=' + toString(this.value_1) + ')';
      }
      hashCode() {
        var result = this.index_1;
        result = imul(result, 31) + (this.value_1 == null ? 0 : hashCode(this.value_1)) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof IndexedValue()))
          return false;
        if (!(this.index_1 === other.index_1))
          return false;
        if (!equals(this.value_1, other.value_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'IndexedValue');
    IndexedValueClass = $;
  }
  return IndexedValueClass;
}
//region block: exports
export {
  IndexedValue as IndexedValue22atz80p92rrf,
};
//endregion

//# sourceMappingURL=IndexedValue.mjs.map
